<template>
    <v-col cols="12" md="2" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">join_full</v-icon> Setup 
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn class="mt-1" 
                                   block
                                   :disabled="!hotel.bookable_via_iescape" 
                                   :href="travelOperators">Travel Operator</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="displayStatus">Display Status</v-btn>
                            <v-btn class="mt-1" 
                                   block
                                   :disabled="!hotel.bookable_via_iescape" 
                                   :href="visitStatus">Visit Status</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="contract">Contract and Format</v-btn>
                            <v-btn class="mt-1" 
                                   block
                                   :disabled="!hotel.bookable_via_iescape" 
                                   :href="bookingSystem">Booking System</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   disabled 
                                   href="">Commission</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="currency">Currency</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   disabled 
                                   href="">Permissions</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     */
    export default {
        props:['results'],

        data: function() {
            return {
				travelOperators: '',
				displayStatus: '',
				visitStatus: '',
				contract: '',
				bookingSystem: '',
				currency: '',
                hotel: null,
                loading: true
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            // Extract the hotel ID from the result set passed into this panel from the dashboard
            var hotelKey = this.results.data[0].hotel_key;
			this.travelOperators = "/hotels/" + hotelKey + "/travel-operators/list";
			this.displayStatus = "/hotels/" + hotelKey + "/display-status/list";
			this.visitStatus = "/hotels/" + hotelKey + "/visits/list",
			this.contract = "/hotels/" + hotelKey + "/contract-format",
			this.bookingSystem = "/hotels/" + hotelKey + "/booking-system/",
			this.currency = "/hotels/" + hotelKey + "/currency/list";

            this.loadHotel();
		},

        methods: {


            loadHotel: function(){
                try {
                    // Extract the hotel ID from the result set passed into this panel from the dashboard
                    var hotelKey = this.results.data[0].hotel_key;

                    axios.get('/api/hotel/' + hotelKey + '/summary-information')
                        .then(function(response){
                            this.hotel = response.data.hotel;
                            this.loading = false;
                        }.bind(this));
                    }
                catch(exception){
                    console.log(exception);
                    this.hasProblem = true;
                }
            },

        }
    }
</script>


